import { Box, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import biIconSmall from '../../Assets/AlertIcon/biIcon.svg';

export const TenantManagementOnLandingPage = () => {
  const tenantId = sessionStorage.getItem('tenantId');
  const navigate = useNavigate();

  return (
    <>
      {' '}
      {(tenantId === null || tenantId === 'null' || tenantId === undefined) && (
        <Box
          sx={{
            width: '100%',
            height: '100%',
            mt: '3%',
            p: '14px 16px',
            bgcolor: 'white',
            boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.08)',
            borderRadius: '16px',
            display: 'inline-flex',
            flexDirection: 'column',
            justifyContent: 'flex-start',
            alignItems: 'flex-start',
            gap: '10px',
            cursor: 'pointer',
            transition: 'all 0.3s cubic-bezier(.25,.8,.25,1)',
            '&:hover': {
              boxShadow: '0 8px 32px 0 rgba(61, 0, 102, 0.25), 0 1.5px 8px 0 rgba(0,0,0,0.10)',
              transform: 'scale(1.04) translateY(-2px)',
              bgcolor: 'linear-gradient(90deg, #f8fafc 0%, #e0e7ff 100%)',
              border: '1.5px solid rgb(192, 169, 230)',
              '& .MuiTypography-root': {
                color: '#7c3aed',
              },
            },
          }}
          onClick={() => navigate('/tenantManagement')}
        >
          <Box
            sx={{
              width: '100%',
              display: 'inline-flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            {/* Left side */}
            <Box sx={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
              <img src={biIconSmall} />
              <Box>
                <Typography
                  sx={{
                    fontSize: '16px',
                    fontFamily: 'Inter',
                    fontWeight: 500,
                    color: '#181818',
                    wordWrap: 'break-word',
                  }}
                >
                  Tenant Management
                </Typography>
                <Typography fontSize={'11px'} align="left" color={'#cccccc'}>
                  Manage Control of the tenants.
                </Typography>
              </Box>
            </Box>
          </Box>
        </Box>
      )}
    </>
  );
};
